<template>
  <div class="carousel">
    <div class="carousel-body" v-hammer:swipe="handleSwipe" @keyup.37="previous" @keyup.39="next">
      <transition :name="direction">
        <component :is="currentSlide" />
      </transition>

      <button class="carousel-next" @click="next">
        <img class="icon" src="@/assets/icons/chevron-right.svg" alt="Next">
      </button>

      <button class="carousel-previous" @click="previous">
        <img class="icon" src="@/assets/icons/chevron-left.svg" alt="Previous">
      </button>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .carousel {
    margin: 0 -20px 30px;

    @include min-md {
      margin: 0;
    }

    .carousel-body {
      overflow: hidden;
      position: relative;
      height: 100%;

      @include min-md {
        border-radius: 4px;
      }

      > img {
        width: 100%;
        height: 60vw;
        object-fit: cover;

        @include min-md {
          height: 100%;
          max-height: 325px;
        }
      }
    }

    .carousel-next,
    .carousel-previous {
      display: block;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);

      .icon {
        width: 3.2rem;
        height: 3.2rem;

        @include min-sm {
          width: 4.2rem;
          height: 4.2rem;
        }
      }
    }

    .carousel-next {
      right: 0;
    }

    .carousel-previous {
      left: 0;
    }

    .slide-next-leave-active,
    .slide-previous-leave-active {
      position: absolute;
    }

    .slide-next-enter-active, 
    .slide-next-leave-active,
    .slide-previous-enter-active, 
    .slide-previous-leave-active {
      transition: transform 0.5s ease;
    }

    .slide-next-enter {
      transform: translateX(100%);
    }

    .slide-next-leave-to {
      transform: translateX(-100%);
    }

    .slide-previous-enter {
      transform: translateX(-100%);
    }

    .slide-previous-leave-to {
      transform: translateX(100%);
    }
  }
</style>

<script>
  function prefetch (asset) {
    let img = new Image();

    img.src = asset;
  };

  export default {
    name: 'Carousel',

    props: {
      items: {
        type: Array,
        required: true
      }
    },

    data: (vm) => ({
      slides: [],
      showSlide: 0,
      direction: `slide-next`
    }),

    computed: {
      currentSlide () {
        if (!this.slides.length) return null;

        return this.slides[this.showSlide].component;
      }
    },

    watch: {
      currentSlide: function (val, oldVal) {
        let previousIndex = this.showSlide - 1;
        let nextIndex = this.showSlide + 1;

        previousIndex = previousIndex > 0 ? previousIndex : this.slides.length - 1;
        nextIndex = nextIndex > this.slides.length - 1 ? 0 : nextIndex;

        let asset = this.direction === `slide-next` ? this.slides[nextIndex].image : this.slides[previousIndex].image;

        prefetch(asset);
      }
    },

    methods: {
      select (i) {
        this.direction = i < this.showSlide ? 'slide-previous' : 'slide-next';
        this.showSlide = i;
      },

      previous () {
        this.direction = `slide-previous`;
        this.showSlide = this.showSlide === 0 ? this.slides.length - 1 : --this.showSlide;
      },

      next () {
        this.direction = `slide-next`;
        
        this.showSlide = this.showSlide === this.slides.length - 1 ? 0 : ++this.showSlide;
      },

      handleSwipe (e) {
        (e.deltaX > 0) ? this.previous() : this.next();
      }
    },

    created () {
      this.slides = this.items.map(el => {
        return {
          image: el,
          component: {
            name: 'Slide',
            render (h) {
              return h('img', {
                attrs: {
                  src: el,
                  alt: ''
                }
              })
            }
          }
        }
      })
    }
  };
</script>